import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @param {string} url
 * @returns
 */
export const url = `v1/community-investment/experience/asset/prices?asset_type=STOCK`;
export async function callbackFetch(stocks) {
  try {
    /** @type {import('./typedefs').Response} */
    const res = await fetcher.post(url, stocks);
    return res.data;
  } catch (err) {
    errorLogger('ERROR_API', err.message);
    throw err;
  }
}
